export const WORKFLOW_ID = 'LargePurchaseWorkflow';
export const BACKEND_KEY = 'LargePurchaseGoal';
export const ANALYTICS_ID = 'large_purchase_workflow';

